import { FC } from 'react';
import { DateTime } from 'luxon';
import Tooltip from '@/components/Tooltip/Tooltip';
import DateLabelProps from '@/components/DateLabel/TooltipDateLabel.types';
import styles from './TooltipDateLabel.module.css';

const TooltipDateLabel: FC<DateLabelProps> = ({ date }) => (
  <span className={styles.tooltipDateLabel}>
    {date ? DateTime.fromISO(date, { zone: 'UTC' }).setZone('local').toLocaleString(DateTime.DATE_SHORT) : '-'}
    <Tooltip
      content={
        date ? DateTime.fromISO(date, { zone: 'UTC' }).setZone('local').toLocaleString(DateTime.DATETIME_FULL) : '-'
      }
      size={12}
    />
  </span>
);

export default TooltipDateLabel;
